import { css } from "@emotion/react"

export const svgContainerStyle = css`
	svg {
		object-fit: contain;
		height: 100%;
	}

	.hotspot--selected path {
		fill: #8ed9ff !important;
	}

	image {
		opacity: 0;
	}
`
